<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PP1"></a><a id="GBS.PP1.w.0.0.0"></a></div><div style="display:none;"><a id="GBS.PR5"></a><a id="GBS.PR5.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PR5.w.0.0.0.1"></a></div><div style="display:none;"><a id="GBS.PR6"></a><a id="GBS.PR6.w.0.0.0"></a></div><div class="flow" style="">
<a class="page full_page_image" id="ORIG-GBS.PP1"></a>
<a id="GBS.PR7"></a><a id="GBS.PR7.w.0.0.0"></a><a id="GBS.PR7.w.0.0.0.1"></a></div>
<div style="display:none;"><a id="GBS.PR7.w.0.0.0.2"></a></div><div style="display:none;"><a id="GBS.PR7.w.1.0.0"></a></div><div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PP3"></a>
<a id="GBS.PR7.w.2.0.0"></a><img alt="Image for page 2" src="data/content-0002.png" style="max-width:100%; max-height:100%"/><a id="GBS.PR7.w.2.0.0.1"></a></div>
<div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PP5"></a>
<a id="GBS.PR7.w.3.0.0"></a><img alt="Image for page 4" src="data/content-0003.png" style="max-width:100%; max-height:100%"/><a id="GBS.PR7.w.3.0.0.1"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PP6"></a>
<a id="GBS.PR7.w.3.1.0"></a><img alt="Image for page 5" src="data/content-0004.png" style="max-width:100%; max-height:100%"/><a id="GBS.PR7.w.3.1.0.1"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PP7"></a>
<div class="gtxt_body" id="block.6.0.0.box.433.753.775.106.q.60">
<a id="ORIG-GBS.PP7.w.0.0.0"></a><p class="gtxt_body gtxt_lineated" id="para.6.0.0.box.433.753.775.106.q.60" style="font-size:102%;text-align:center;font-weight:bold;margin-left:0;"><span style="font-style:italic;"> Remembering </span><span style="font-style:italic;">Stasia, </span><span style="font-style:italic;">my </span><span style="font-style:italic;">mother</span>— <br/><span style="font-style:italic;">her </span><span style="font-style:italic;">vibrant </span><span style="font-style:italic;">spirit, </span><span style="font-style:italic;">her </span><span style="font-style:italic;">questing </span><span style="font-style:italic;">mind </span><br/></p>
</div>
</div>
<div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PP9"></a>
<div class="gtxt_body" id="block.8.0.0.box.178.733.491.44.q.90">
<a id="ORIG-GBS.PP9.w.0.0.0"></a><p class="gtxt_body" id="para.8.0.0.box.178.733.491.44.q.90" style="font-size:107%;text-indent:1em;font-weight:bold;text-indent:0;"><a id="GBS.PR7.w.3.2.0"></a>ILLUSTRATIONS</p><a id="GBS.PR7.w.3.3.0"></a><a id="GBS.PR7.w.3.4.0"></a>
</div><a id="GBS.PR7.w.4.0.0"></a><a id="GBS.PR7.w.5.0.0"></a>
<div class="gimg_graphic" id="block.8.1.0.box.164.812.1333.765.q.50"><a id="GBS.PR7.w.6.0.0"></a>
<a id="GBS.PR7.w.7.0.0"></a><img alt="[graphic]" src="data/content-0005.png" style="max-width:100%; max-height:100%"/><a id="GBS.PR7.w.7.0.0.1"></a></div><a id="GBS.PR7.w.8.0.0"></a><a id="GBS.PR8"></a><a id="GBS.PR8.w.0.0.0"></a>
<div class="gtxt_body" id="block.8.2.0.box.181.1669.169.43.q.70">
<a id="ORIG-GBS.PP9.w.2.0.0"></a><p class="gtxt_body" id="para.8.2.0.box.181.1669.169.43.q.70" style="font-size:107%;text-indent:1em;font-weight:bold;text-indent:0;">MAPS</p>
</div>
<div class="gimg_graphic" id="block.8.3.0.box.181.1767.1254.152.q.50">
<a id="GBS.PR9"></a><a id="GBS.PR9.w.0.0.0"></a><img alt="[graphic]" src="data/content-0006.png" style="max-width:100%; max-height:100%"/><a id="GBS.PR9.w.0.0.0.1"></a></div>
</div>
<div style="display:none;"><a id="GBS.PR9.w.0.0.0.2"></a></div><div style="display:none;"><a id="GBS.PR9.w.1.0.0"></a></div><div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PP11"></a>
<div class="gtxt_body" id="block.10.0.0.box.307.721.1006.574.q.60">
<a id="ORIG-GBS.PP11.w.0.0.0"></a><p class="gtxt_body gtxt_quote" id="para.10.0.0.box.307.721.1006.393.q.60">Early in our industrial history this valley was the seat of the largest development of inland navigation in the United States; and perhaps you will pardon my mentioning that the first steamboat west of the Alleghanies [sic] was built by a Roosevelt, my great-grandfather's brother, in 1811, for the New Orleans trade, and in that year made the trip from Pittsburgh to New Orleans.</p>
<a id="ORIG-GBS.PP11.w.0.1.0"></a><p class="gtxt_body gtxt_lineated" id="para.10.0.1.box.725.1154.587.141.q.60" style="text-align:right;margin-right:2em;">—<span style="font-style:italic;">Theodore </span><span style="font-style:italic;">Roosevelt, </span><span style="font-style:italic;">in </span><span style="font-style:italic;">a </span><span style="font-style:italic;">speech </span><span style="font-style:italic;">made </span><br/><span style="font-style:italic;"><a id="GBS.PR9.w.1.1.0"></a>  at </span><span style="font-style:italic;">the </span><span style="font-style:italic;">Deep </span><span style="font-style:italic;">Waterway </span><span style="font-style:italic;">Convention </span><span style="font-style:italic;">at </span><br/><span style="font-style:italic;"><a id="GBS.PR10"></a><a id="GBS.PR10.w.0.0.0"></a>  Memphis, </span><span style="font-style:italic;">Tennessee, </span><span style="font-style:italic;">October </span><span style="font-style:italic;">4, </span><span style="font-style:italic;">1907 </span><br/></p>
</div>
</div><div style="display:none;"><a id="GBS.PR11"></a><a id="GBS.PR11.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PR11.w.0.0.0.1"></a></div><div style="display:none;"><a id="GBS.PR11.w.0.0.0.2"></a></div><div class="flow" style="">
</div>
<div style="display:none;"><a id="GBS.PR11.w.0.0.0.3"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content0007.vue?547d8ab7